import React from 'react';
import classnames from 'classnames/bind';
import { isEqual } from 'lodash';
import { Button } from 'tuui';
import { FormattedMessage } from '../../../../modules/taboola-common-frontend-modules/i18n';
import styles from './subFilters.module.scss';

const classNameBuilder = classnames.bind(styles);

export const SubFilters = ({ filters, onClick, selectedSubFilters }) => {
    const comps = filters.map((filter, index) => {
        const isSelected = selectedSubFilters.some(subFilter => isEqual(subFilter, filter));

        return (
            <div className={classNameBuilder('button-container', { selected: isSelected })} key={index}>
                <Button
                    key={index}
                    onClick={() => onClick(filter)}
                    className={classNameBuilder('filter-button', { selected: isSelected })}
                >
                    <FormattedMessage
                        id={`campaign.editor.targeting.audience.details.${filter.filterValue}`}
                        defaultMessage="{detail}"
                        values={{ detail: filter.filterName }}
                    />
                </Button>
            </div>
        );
    });

    return <div className={styles['container']}>{comps}</div>;
};
